<label *ngIf="label != null && label != '' && showLabel" class="sumax-label mb-0 p-0">{{label}}<span *ngIf="required"
		[class.text-danger]="controls?.errors != null"> *</span></label>
<div [class.input-icon]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
	[class.right]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted">
	<!-- tooltip-message es el icono de error -->
	<tooltip-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage" [submitted]="submitted"
		[tooltipMessage]="tooltipMessage"></tooltip-message>
	<div class="d-flex p-0 group-input-button">
		<input type="text" [autocomplete]="autocomplete"
			[class.is-invalid]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
			[disabled]="disabled" [readonly]="readonly" (keyup.enter)="onKeyUpEnter($any($event.target).value)"
			(keyup.ArrowUp)=" arrowUpKeyUp()" (keypress)="onlyNumbers($event)" (input)="onInput($any($event.target).value)"
			(dateSelect)="onInput($event)" (focus)="onFocus($any($event.target).value)"
			(focusout)="focusOut($any($event.target).value)" (blur)="onBlur($any($event.target).value)"
			class="form-control form-control-sm rounded-left use-input" container="body" placeholder="dd/mm/yyyy"
			[minDate]="minDate" [maxDate]="maxDate" name="fecha" ngbDatepicker #fecha="ngbDatepicker"
			[(ngModel)]="value">
		<button type="button" [disabled]="disabled || readonly" class="btn btn-info p-0 rounded-0 use-button" (click)="fecha.toggle()">
			<!-- <mat-icon class="text-white pt-1" style="font-size: 18px;" [matTooltip]="'Calendario'" matTooltipClass="bg-info">calendar_today</mat-icon> -->
			<i class="fa fa-calendar text-white px-1" aria-hidden="true"></i>
		</button>
	</div>
</div>
<!-- error-message es el mansaje que aparece abajo del componente -->
<error-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage" [submitted]="submitted"
	[tooltipMessage]="tooltipMessage"></error-message>